import { render } from "./OltDetails.vue?vue&type=template&id=3b71bdbf&scoped=true"
import script from "./OltDetails.vue?vue&type=script&lang=js"
export * from "./OltDetails.vue?vue&type=script&lang=js"

import "./OltDetails.vue?vue&type=style&index=0&id=3b71bdbf&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\oltcare-front\\olt_care\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b71bdbf"]])

export default __exports__